<template>
  <div id="quanteecWindow" ref="quanteecWindow">
      <!--<div class="fixedButton">
          <b-button variant="msstreamblue" @click="openWindow('New VoD dsfsjmfjljfjsqfddsfmjqkjfdsjmdsjfjdshfs', 'elem')">
              +
          </b-button>
      </div>-->
      <div v-for="(window, index) in windows" v-bind:key="window.title">
        <div :ref="'window' + window.title" class="fixedWindow otherWindow">
            <div  v-if="!window.reduced" class="windowHeader windowBodyWidth">
                    <b-row class="justify-content-between align-items-center">
                        <b-col cols="6" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                            <strong>{{window.title}}</strong>
                        </b-col>
                        <b-col cols="auto" style="padding-right: 0px;">
                            <b-btn v-if="window.elem.type === 'Chat'" variant="invisible" @click="popupWindow(index)">
                                <font-awesome-icon icon='external-link-alt' ></font-awesome-icon>
                            </b-btn>
                            <b-btn variant="invisible" @click="reduceWindow(index)">
                                <font-awesome-icon :icon="['fas', 'angle-down']" ></font-awesome-icon>
                            </b-btn>
                            <b-btn v-if="window.closable" variant="invisible" @click="checkLiveWindow(index)">
                                <font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon>
                            </b-btn>
                        </b-col>
                    </b-row>
            </div>
            <div class="windowBody windowBodyWidth windowBodyHeight" :class="{'noDisplay': window.reduced}">
                <b-container fluid>
                    <VideoForm :componentType="window.elem.options.componentType" :specificVideoID="window.elem.options.specificVideoID" v-if="window.elem.type === 'VideoForm'" class="marginaltop align-self-center"></VideoForm>
                    <Chat v-if="window.elem.type === 'Chat'"></Chat>
                    <ProjectForm v-if="window.elem.type ==='ProjectForm'"></ProjectForm>
                </b-container>
                <div v-if="windowLength >= 2" style="padding-bottom: 50px;"></div>
            </div>
            
        </div>
      </div>
      <div v-if="windowLength > 0 && (allReduced || windowLength >= 2)" class="fixedWindow otherWindow windowHeaderSmall">
        <b-row class="justify-content-between align-items-center">
            <b-col v-if="windowLength >= 2" cols="1" class="text-center" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; padding-right: 0px;padding-left:0px;">
                <small>{{windowLength}}</small>
            </b-col>
            <b-col v-if="windowLength >= 2" cols="8" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; padding-right: 0px; padding-left:0px;">
                <b-form-select size="sm" v-model="selected" :options="options" @change="openWindow(selected)"></b-form-select>
            </b-col>
            <b-col v-if="windowLength === 1" cols="9" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; padding-right: 0px; padding-left:0px;">
                <small><strong>{{selected}}</strong></small>
            </b-col>
            <b-col v-if="allReduced" cols="auto" style="padding-right: 0px;padding-left: 0px;">
                <b-btn variant="invisible" size="sm" @click="openWindow(selected)">
                    <font-awesome-icon :icon="['fas', 'angle-up']" ></font-awesome-icon>
                </b-btn>
            </b-col>
            <b-col v-if="!allReduced" cols="auto" style="padding-right: 0px;padding-left: 0px;">
                <b-btn variant="invisible" size="sm" @click="reduceWindow(selected)">
                    <font-awesome-icon :icon="['fas', 'angle-down']" ></font-awesome-icon>
                </b-btn>
            </b-col>
        </b-row>
    </div>       

    <b-modal ref="webcamClose" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>A live/preview is currently running</h3>
      </div>
      <div class="marginal">
        A live/preview with webcam may be currently running on this window, do you really want to close it ?
      </div>
          <b-row style="margin-top:15px">
      <div class="col-md-2"></div>
      <b-button class="col-md-3" @click="isPreviewWebcam=false; hideModal('webcamClose'); closeWindow(indexToClose)" variant="mswarning">
        <font-awesome-icon icon="check" />
        Validate
      </b-button>
      <div class="col-md-2"></div>
      <b-button class="col-md-3" @click="hideModal('webcamClose')" variant="quanteeclg">
        <font-awesome-icon style="color:red" icon="times" />
        Cancel
      </b-button>
    </b-row>
    </b-modal>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import VideoForm from '@/components/VideoForm';
import Chat from '@/components/Chat'
import ProjectForm from '@/components/VireedProjectForm'
export default {
  name: 'Window',
  components: {
     VideoForm,
     Chat,
     ProjectForm
  },
  data: function() {
      return {
          isOpen: false,
          isReduced: false,
          windows: [],
          selected: '',
          options: [],
          allReduced: false,
          windowLength: 0,
          isPreviewWebcam:false,
          indexToClose:-1,
      }
  },
  mounted() {
      let self = this;
      EventBus.$on("windowVoD", this.openWindow.bind(self, 'New Video(s)', {type: 'VideoForm', options: {'componentType':'vod', 'specificVideoID': null}}));
      EventBus.$on("windowLive", this.openWindow.bind(self, 'New Live', {type: 'VideoForm', options: {'componentType':'live', 'specificVideoID': null}}));
      EventBus.$on("chat", this.openWindow.bind(self, 'Chat', {type: 'Chat', options: {}}));
      EventBus.$on("projectForm", this.openWindow.bind(self, 'New Project', {type: 'ProjectForm', options: {}}));

      EventBus.$on("reduceWindows", this.reduceWindows.bind(self));
      EventBus.$on("preventCloseWindow", this.preventClose.bind(self));
      EventBus.$on("allowCloseWindow", this.allowClose.bind(self));

      EventBus.$on("closeCurrentWindow", this.closeCurrentWindow.bind(self));
      EventBus.$on("closeAllWindows", this.closeAllWindows);
  },
  methods:{
      showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
      verifyAllReduced() {
        this.allReduced = this.windows.findIndex(x => x.reduced === false) === -1;  
        this.windowLength = this.windows.length;
      },
      regenerateOptions() {
        this.options = this.windows.map(x => x.title);
        this.windowLength = this.windows.length;
      },
      createNewWindow(title, elem) {
          this.windows = this.windows.map(x => {return {...x, reduced: true}});
          this.windows.push({
              title: title, 
              elem: elem, 
              reduced: false,
              closable: true
            });
            this.regenerateOptions()
            this.selected = title;
;      },
      openWindow(title, elem, event) {
          if (title === "New Live") {
              if (event) {
                  elem.options = {...elem.options, ...event};
              }
              let thisNumber = 1;
              let listOfNewLive = this.windows.filter(x => x.title.indexOf("New Live") > -1);
              if (listOfNewLive.length > 0) {
                let numbers = listOfNewLive.map(x => +x.title.replace('New Live - ', ''));
                numbers = numbers.sort();
                thisNumber = numbers[numbers.length - 1] + 1;
              }
              title = "New Live - " + thisNumber 
          }

          let index = this.windows.findIndex(x => x.title === title);
          if (index === -1) {
            this.windows = this.windows.map(x => {return {...x, reduced: true}});
            this.createNewWindow(title, elem);
          } else {
            this.windows = this.windows.map(x => {return {...x, reduced: true}});
            this.windows[index].reduced = false;
          }
          this.verifyAllReduced();
      },
      reduceWindow(index) {
          if (typeof index === 'string') {
            index = this.windows.findIndex(x => x.title === index)
          }
          this.windows[index].reduced = true;
          this.verifyAllReduced();
          this.selected = this.windows[index].title;
      },
      reduceWindows() {
          this.windows = this.windows.map(x => {return {...x, reduced: true}});
          this.verifyAllReduced();
      },
      preventClose(title) {
          let index = this.windows.findIndex(x => x.title === title);
          this.windows[index].closable = false;
      },
      allowClose(title) {
          let index = this.windows.findIndex(x => x.title === title);
          this.windows[index].closable = true;
      },
      closeWindow(index) {

          

            let modifySelected = false
            if (this.windows[index].title === this.selected && this.windows.length > 1) {
                modifySelected = true;
            }
            this.windows.splice(index, 1);
            if (modifySelected) {
                this.selected = this.windows[0].title;
            }
            this.regenerateOptions();
            this.verifyAllReduced();
      },
      checkLiveWindow(index)
      {
          /*
          if(this.windows[index].title.includes("New Live"))
          {
              this.indexToClose = index;
              this.showModal("webcamClose")
          }
          else{*/
              this.closeWindow(index)
          //}
      },
      closeAllWindows() {
        this.windows = [];
        this.regenerateOptions();
        this.verifyAllReduced();
      },
      popupWindow(index)
      {
          window.open("#/chat","Chat","width=1200, height=750");
          this.closeWindow(index)
      },
      closeCurrentWindow()
      {
          this.windows.forEach((window, index) =>{
              if(!window.reduced)
                this.closeWindow(index)
          })
      }
  }
}
</script>
<style scoped lang="scss">
.windowContainer {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
}
.fixedButton {
    position: fixed;
    right: auto;
    bottom: 0px;
    left: 0px;
    top: auto;
    transform: translate(-50%,-50%);
    z-index: 4;
}

.fixedWindow {
    position: fixed;
    z-index: 3;
}

.otherWindow {
    bottom: 0px;
    right: 0px;
    top: auto;
    left: auto;
}

.windowHeader {
    padding: .75rem 1.25rem;
    margin-bottom: 0;
    background-color:  rgba(17, 52, 72, 1)!important;
    color: white !important;
    border: 1px solid black;
    border-radius: 8px 8px 0px 0px;

}

.windowHeaderSmall {
    padding: .25rem 1.25rem;
    margin-bottom: 0;
    background-color: rgba(17, 52, 72, 0.9)!important;
    color: white !important;
    border: 1px solid #113448;
    border-radius: 8px 8px 0px 0px;
    width: 200px;
}

.windowBody {
    border: 1px solid #113448;
    background-color: #fff;
}

.noDisplay {
    display: none;
}

.windowBodyHeight {
    height: 50vh;
    max-height: 50vh;
    overflow-y: auto;
}

.windowBodyWidth {
    width: 45vw;
}

@media (max-width: 1200px) {
    .windowBodyWidth {
        width: 50vw;
    }
}

@media (max-width: 992px) {
    .windowBodyWidth {
        width: 60vw;
    }
}

@media (max-width: 768px) {
    .windowBodyWidth {
        width: 70vw;
    }
}

@media (max-width: 576px) {
    .windowBodyWidth {
        width: 100vw;
    }
}

@media (max-height: 700px) {
    .windowBodyHeight {
        height: 70vh;
        max-height: 70vh;
        overflow-y: auto;
    }
}

@media (max-height: 500px) {
    .windowBodyHeight {
        height: 75vh;
        max-height: 75vh;
        overflow-y: auto;
    }
}


</style>